
export class WebglSettings {
    public meshLevel: number = 1;
    public interactiveProject: boolean = false;
    public smartContent: boolean = false;
    public mirrors: boolean = true;
    public fxaa: boolean = true;
    public cellShading: boolean = true;
    public display: number = 0;
    public hullbin: boolean = true;
}
